/**
 * /*
 * =====================================================================
 * --------------------------- API SERVICES ----------------------------
 * =====================================================================
 *
 * @format
 */

import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import localStorageServices from './jwt.services'
import router from '../router'

import { API_URL } from '@/common/config'

/**
 * @name @ApiService
 * @description Default Api Service for Auth and Defaul Queries
 * */

/* General ApiSeervice Requests and configurations */
const ApiService = {
  /* initialize axios */
  init () {
    Vue.use(VueAxios, axios)
    Vue.axios.defaults.baseURL = API_URL

    Vue.axios.interceptors.response.use(
      function (response) {
        // Do something with response data
        return response
      },
      function (error) {
        if (error.response && error.response.status === 401) {
          localStorageServices.destroyObject('Auth')
        }
        // Do something with response error
        return Promise.reject(error)
      }
    )
  },

  /* Setting Auth Header */
  setHeader () {
    if (JSON.parse(localStorageServices.getObject('Auth'))) {
      Vue.axios.defaults.headers.common['Authorization'] = `${
        JSON.parse(localStorageServices.getObject('Auth')).token
      }`
    }
  },


  /* General query for get request */
  query (resource, params) {
    return Vue.axios.get(resource, params).catch(error => {
      throw new Error(`TicketBox Generic ApiService ${error}`)
    })
  },

  /* General get request */
  get (resource, params) {
    params = params ? `${resource}/${params}` : `${resource}`
    return Vue.axios.get(params)
  },

  /* Get request with params */
  getWithParams (resource, params) {
    return Vue.axios.get(resource, params).catch(error => {
      throw new Error(`TicketBox Get ApiService ${error}`)
    })
  },
  getWithQueryParams(resource, params = null) {
    // Convert params object to query string
    let queryString = '';
    if (typeof params === 'object' && params !== null) {
      queryString = '?' + new URLSearchParams(params).toString();
    }
    return Vue.axios.get(`${resource}${queryString}`).catch(error => {
      throw new Error(`TicketBox Get ApiService ${error}`);
    });
  },
  /* General post request */
  post (resource, params) {
    return Vue.axios.post(resource, params)
  },

  /* General put request */
  put (resource, params) {
    return Vue.axios.put(resource, params)
  },

  /* General delete request */
  delete (resource, params) {
    return Vue.axios.delete(`${resource}/${params}`).catch(error => {
      throw new Error(`TicketBox Delete ApiService ${error}`)
    })
  }
}

/* Export ApiService as default */
export default ApiService
